import { useBuilderStore } from '../../store/builderStore';
import { cn } from '@printtat/ui';
export const ColorPicker = () => {
  const availableColors = useBuilderStore((s) => s.availableColors);
  const enabledColors = useBuilderStore((s) => s.enabledColors);
  const selectedColor = useBuilderStore((s) => s.selectedColor);
  const setSelectedColor = useBuilderStore((s) => s.setSelectedColor);

  const visibleColors = availableColors.filter((c) =>
    enabledColors.includes(c.name),
  );

  if (visibleColors.length <= 1) return null;

  return (
    <div className="flex items-center gap-2 px-2 pt-4 pb-1.5 bg-white/90 backdrop-blur-sm rounded-lg border border-gray-200 shadow-sm -translate-y-4">
      {visibleColors.map((color) => {
        const isActive = selectedColor?.name === color.name;
        return (
          <button
            key={color.name}
            onClick={() => setSelectedColor(color)}
            className="relative flex items-center gap-1"
          >
            {isActive && <span className="w-2 h-2 rounded-full bg-green-500 left-2.5 border-white border top-[0.02rem] absolute"></span>}
            <span
              className={cn(
                "inline-flex min-w-4 min-h-4 rounded-full border border-gray-400 transition-all cursor-pointer flex-shrink-0",
                isActive
                  ? "border-gray-400 ring-1.5 ring-gray-900/20"
                  : "border-gray-200 hover:border-gray-400",
              )}
              style={{ backgroundColor: color.hex }}
            />
            <span
              className={cn(
                "text-[11px] leading-[12px] text-gray-500 font-medium mt-0.5",
                isActive ? "text-gray-900" : "text-gray-500",
              )}
            >
              {color.name}
            </span>

          </button>
        );
      })}
    </div>
  );
};
